import type { ModalFooterButtonEvent } from './ModalFooter/types';

type FooterButtonTestId = 'footer-cancel' | 'footer-confirm';

const resolveFooterButtonTestId = (
  eventType?: ModalFooterButtonEvent,
): FooterButtonTestId | undefined => {
  if (!eventType) return undefined;

  return eventType === 'cancel' || eventType === 'close' ? 'footer-cancel' : 'footer-confirm';
};

export { resolveFooterButtonTestId };

export type { FooterButtonTestId };
